const mixin = {
    methods: {
        dataDollarReplacement(element) {
            element.querySelectorAll('[data-dollar]').forEach((node) => {
                let value = node.innerText;
                value = value.replace(/[^0-9.]/g, '');
                value = parseFloat(value);
                if (isNaN(value)) {
                    return;
                }

                value = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                })
                    .format(value)
                    .replace('$', '');
                node.innerText = value;
            })
        }
    }
};

export default mixin;
